import classNames from 'classnames';
import * as React from 'react';

import {
  IPhotoStubSchema,
  EBackground,
} from '../../../../../shared/repositories/search-offers.legacy/v2/types/PhotoStubSchema';
import styles from './OfferGalleryPessimizationFlexible.css';

interface IOfferGalleryPessimizationFlexibleProps {
  photoStub: IPhotoStubSchema;
}

export const OfferGalleryPessimizationFlexible = ({
  photoStub: { text, background },
}: IOfferGalleryPessimizationFlexibleProps) => {
  return (
    <div className={classNames(styles['pessimization'], background === EBackground.Red && styles['strong'])}>
      {text}
    </div>
  );
};

OfferGalleryPessimizationFlexible.displayName = 'OfferGalleryPessimizationFlexible';
